import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RouterModule } from '@angular/router'

import { HeroSplit } from 'app/core/cms/generated/api-types'
import { PictureComponent } from 'app/shared/picture/picture.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-hero-split',
  templateUrl: './hero-split.component.html',
  styleUrls: ['./hero-split.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, PictureComponent],
  providers: [{ provide: CmsBlock, useExisting: HeroSplitComponent }],
})
export class HeroSplitComponent extends CmsBlock<HeroSplit> {
  readonly __typename = 'HeroSplit'

  // todo: we first need to re-add it in the cms schema
  // readonly cta = computed(() => this.data()?.cta?.[0] ?? null)
}
